type OrganisationLogoSources = {
  organisation_images?: ReadonlyArray<{
    image: { url?: string | null };
  }> | null;
  teams?: ReadonlyArray<{ logo?: { url?: string | null } | null }> | null;
};

/**
 * Resolve an organisation's logo, falling back to one of its teams' logo when
 * the organisation itself has no image.
 */
export const getOrganisationLogoUrl = (
  organisation: OrganisationLogoSources,
): string | null => {
  const organisationImageUrl =
    organisation.organisation_images?.[0]?.image?.url ?? null;
  if (organisationImageUrl != null) {
    return organisationImageUrl;
  }

  for (const team of organisation.teams ?? []) {
    if (team.logo?.url != null) {
      return team.logo.url;
    }
  }

  return null;
};
